export const companyStrings = {
  company: {
    id: 'ID',
    name: 'Name',
    addendum: 'Zusatz',
    city: 'Ort',
    street: 'Straße',
    zipCode: 'Postleitzahl',
    postBox: 'Postfach',
    contactName: 'Kontakt - Name',
    contactPhone: 'Kontakt - Telefon',
    contactFax: 'Kontakt - Fax',
    contactMail: 'Kontakt - E-Mail',
    contactIsExportResponsible: 'Kontakt - Abrufverantwortlicher',
    secondName: 'Zweitperson - Name',
    secondPhone: 'Zweitperson - Telefon',
    secondFax: 'Zweitperson - Fax',
    secondMail: 'Zweitperson - E-Mail',
    checkNumber: 'Kontrollnummer',
    eoriNumber: 'EORI-Nr.',
    website: 'Webseite',
    status: 'Status',
    classification: 'Klassifikation',
    isActive: 'Aktiv',
    isActiveOverride: 'Aktiv-Status manuell überschrieben',
    isActiveOverrideInfo:
      'Der Aktiv-Status dieser Firma wird durch den BAFA-Import nicht mehr automatisch geändert (weder aktiviert noch deaktiviert).',
    isActiveOverrideReset: 'Zurücksetzen',
    inUse: 'In Benutzung',
    filterByInUse: 'In Benutzung',
    filterInUseAll: 'Alle',
    filterInUseActive: 'Nur in Benutzung',
    filterInUseInactive: 'Nur nicht in Benutzung',
    renameDate: 'Datum der Umbenennung',
    history: 'Änderungshistorie',
    historyValidFrom: 'Gültig ab',
    historyValidTo: 'Gültig bis',
    modified: 'Geändert',
    country: 'Land',
  },
  entitySingular: 'Firma',
  entityPlural: 'Firmen',
  messages: {
    deletion: {
      success: (name: string) => `Firma "${name}" wurde erfolgreich gelöscht`,
      error: 'Firma konnte nicht gelöscht werden',
    },
    update: {
      success: 'Firma erfolgreich aktualisiert',
      error: 'Firma konnte nicht aktualisiert werden',
    },
    create: {
      success: 'Firma erfolgreich erstellt',
      error: 'Firma konnte nicht erstellt werden',
    },
    bafaImport: {
      title: 'BAFA-Firmenliste importieren',
      label: 'BAFA-Firmenliste importieren',
      selectFile: 'Excel-Datei auswählen',
      chooseFile: 'Datei auswählen',
      noFileSelected: 'Keine Datei ausgewählt',
      action: 'Importieren',
      success: 'BAFA-Firmenliste erfolgreich importiert',
      error: 'Fehler beim Importieren der BAFA-Firmenliste',
      warnings: {
        title: 'Import mit Warnungen abgeschlossen',
        description:
          'Der Import wurde erfolgreich durchgeführt. Folgende Datenprobleme wurden festgestellt und automatisch behandelt:',
        duplicateAlpha2: (alpha2: string, chosenName: string) =>
          `Mehrere Länder mit Alpha2-Code "${alpha2}" gefunden. Verwendet wurde "${chosenName}".`,
        duplicateAlpha2Skipped: (names: string) => `Ignoriert: ${names}`,
        close: 'Schließen',
      },
    },
  },
};
